import styled, { createGlobalStyle } from 'styled-components'

export const WishlistDrawerGlobalStyles = createGlobalStyle`
  .wishlist-drawer {
    .wishlist-drawer-content {
      overflow: hidden !important;
      scrollbar-width: none !important;
      -ms-overflow-style: none !important;
      
      &::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
      }
    }
  }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`

export const WishlistGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-right: 1.2rem;
  padding-left: 1.2rem;
  flex: 1;
  overflow-y: auto;
`

export const EmptyMessage = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.text.light};
  font-size: 1.4rem;
  font-weight: 400;
  margin: 2rem 0;
`

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.danger};
  font-size: 1.4rem;
  font-weight: 400;
  margin-top: 1rem;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.boxBackground};
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.2rem;
  box-shadow: 0px -1px 11px 0px #00000061;
  background-color: ${({ theme }) => theme.colors.background};
  margin-top: auto;
  flex-shrink: 0;
  z-index: 1060;
`
